<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>账户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="账户ID"
                        prop="id">
            <el-input placeholder="请输入账户ID"
                      clearable
                      v-model="search.id" />
          </el-form-item>
          <el-form-item label="账户名称"
                        prop="name">
            <el-input placeholder="请输入名称"
                      clearable
                      v-model="search.name" />
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button icon="sj-icon-export"
                     @click="onExportSearch()">导出
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="sj-icon-export"
                   @click="onExportPage()"></el-button>
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <el-button type="primary"
                   icon="sj-icon-add"
                   @click="$refs['companyAccountForm'].show()"
                   size="small">添加
        </el-button>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <template v-for="(attr, index) of companyAccountFields">
          <el-table-column :key="index" v-bind="attr"></el-table-column>
        </template>
        <el-table-column fixed="right"
                         label="操作"
                         width="260">
          <template slot-scope="scope">
            <button-gutter>
              <el-button size="mini"
                         @click="$refs['companyAccountForm'].show(scope.row.id)"
                         type="primary"> 修改
              </el-button>
              <el-button size="mini"
                         type="success"
                         v-if="scope.row.is_disabled"
                         @click="enable(scope.row.id)"> 启用
              </el-button>
              <el-button size="mini"
                         type="danger"
                         v-if="!scope.row.is_disabled"
                         @click="disable(scope.row.id)"> 禁用
              </el-button>
            </button-gutter>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

    <company-account-form-dialog @submitted="onSearch" ref="companyAccountForm" />
  </div>
</template>

<script>
import CompanyAccountManagementFormDialog from './CompanyAccountManagementFormDialog'
import financelConfigMixins from '../../finance-config.mixins'
import { searchRules } from '../../finance-config.rules'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table-v3'

export default {
  mixins: [table, dateTimePicker, financelConfigMixins],
  components: {
    CompanyAccountFormDialog: CompanyAccountManagementFormDialog
  },
  data () {
    return {
      searchRules,
      search: {
        id: null,
        name: null,
      }
    }
  },
  computed: Vuex.mapState({}),
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getCompanyAccountManagementTable', params)
    },
    onExportPage () {
      this.$export(`${this.$route.meta.title}-${this.pagination.current_page}P`, this.table, {
        fileHeader: this.companyAccountFields,
        keyName: 'prop',
        labelName: 'label'
      })
    },
    onExportSearch () {
      this.$export(this.$route.meta.title, {
        fileHeader: this.companyAccountFields,
        keyName: 'prop',
        labelName: 'label',
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
      })
    },
    enable (id) {
      this.$confirm('确认要启用吗?', '提示', {type: 'warning'}).then(() => {
        request.common('enableOurCompanyAccount', {id}).then(() => {
          this.$message.success('启用成功')
          this.onSearch()
        })
      }).catch(() => {
        this.$message.info('已取消该操作')
      })
    },
    disable (id) {
      this.$confirm('确认要禁用吗?', '提示', {type: 'warning'}).then(() => {
        request.common('disableOurCompanyAccount', {id}).then(() => {
          this.$message.success('禁用成功')
          this.onSearch()
        })
      }).catch(() => {
        this.$message.info('已取消该操作')
      })
    }
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/finance-config/pages/company-account-management/CompanyAccountManagementTable.vue